export class FieldInvalid {
  constructor(fieldName, groupName, groupIndex) {
    this.fieldName = fieldName;
    this.groupName = groupName;
    this.groupIndex = groupIndex;
  }
}
